import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { Mail, Lock, Loader2 } from 'lucide-react';

/**
 * LoginForm — email + password, with autoComplete for browser password managers.
 */
export default function LoginForm({
  email, setEmail,
  password, setPassword,
  loading,
  onSubmit,
  onSwitchToRegister,
  onSwitchToReset,
}) {
  return (
    <form
      onSubmit={onSubmit}
      className="space-y-4 mt-2"
      method="post"
      action="#"
      autoComplete="on"
      data-testid="auth-form"
    >
      <div className="space-y-2">
        <Label htmlFor="email" className="text-sm text-zinc-300">Email</Label>
        <div className="relative">
          <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
          <Input
            id="email" name="email" type="email" required value={email}
            autoComplete="email" inputMode="email"
            onChange={(e) => setEmail(e.target.value)}
            placeholder="toi@email.com"
            className="pl-9 bg-white/5 border-white/10 text-white h-11 rounded-xl"
            data-testid="auth-email-input"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="password" className="text-sm text-zinc-300">Mot de passe</Label>
        <div className="relative">
          <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
          <Input
            id="password" name="password" type="password" required value={password}
            autoComplete="current-password"
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••" minLength={6}
            className="pl-9 bg-white/5 border-white/10 text-white h-11 rounded-xl"
            data-testid="auth-password-input"
          />
        </div>
      </div>

      <Button type="submit" disabled={loading} className="w-full h-11 btn-neon text-white border-0 rounded-xl font-bold" data-testid="auth-submit-btn">
        {loading ? <Loader2 size={18} className="animate-spin" /> : 'Se connecter'}
      </Button>

      <div className="text-center text-sm text-zinc-400 space-y-1">
        <div>Pas encore de compte ?{' '}
          <button type="button" onClick={onSwitchToRegister} className="text-pink-400 font-semibold hover:text-pink-300" data-testid="switch-to-register">
            Inscris-toi
          </button>
        </div>
        <div>
          <button type="button" onClick={onSwitchToReset} className="text-zinc-400 hover:text-pink-300 underline-offset-2 hover:underline" data-testid="switch-to-reset">
            Mot de passe oublié ?
          </button>
        </div>
      </div>
    </form>
  );
}
